import AxiosInstance from "services/api";

const endpoint = "/private/customer-payment-details-ledgers";

export const CustomerPaymentDetailsLedgerService = {
  getPaginate: async (params) => {
    return await AxiosInstance.get(`${endpoint}/paginate`, { params });
  },

  create: async (payload) => {
    return await AxiosInstance.post(endpoint, payload);
  },

  getById: async (id) => {
    return await AxiosInstance.get(`${endpoint}/${id}`);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch(`${endpoint}/${id}`, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete(`${endpoint}/${id}`);
  },
};
